import { SchedulerPopupComponent, SchedulerPopupState } from './types';

export function getOpenPopupComponent(
  popup: SchedulerPopupState | null,
): SchedulerPopupComponent | null {
  if (!popup) return null;
  return parseInt(Object.keys(popup ?? {})[0], 10) as SchedulerPopupComponent;
}
